/**
 * The full BU list. Confirmed to be fixed rather than served by the backend, so
 * it is hard-coded in the frontend. Order matches the list the business owners
 * provided.
 *
 * Every place in the module that needs a BU reads this one list — do not keep a
 * second copy. The mockup drifted exactly that way: the "belonging BU" dropdown
 * said `MFG` / `Auto` while the per-BU goal table said `AUTO & MFG`, so the same
 * BU appeared under two spellings.
 */
export const BUSINESS_UNITS = [
  "STRATEGIC",
  "DNBP",
  "RFHC",
  "MEAGS",
  "AUTO & MFG",
  "ISV & SUP",
  "IND GFD",
  "SMB",
  "PARTNER",
  "NWCD",
  "Digital + New Accounts",
  "FSI-DNB",
  "HK",
] as const;

/** Sentinel for single-select BU fields meaning "not scoped to any one BU". */
export const ALL_BUS = "All";
